// extracted by mini-css-extract-plugin
export default {"Icon-ocean":"theme-ocean_Icon-ocean__9Bkk7"};